<script>
import ViewHeader from '@/components/ViewHeader.vue';
import SatelliteApi from '@/data/SatelliteApi.ts';

export default {
  name: 'SupportView',
  components: { ViewHeader },
  data() {
    return {
      selectedCategory: null,
      categories: [],
      subtitle: 'Heb je een probleem met je zonnepanelen?',
      topText:
        'We helpen je graag verder. Hieronder vind je de meest gestelde vragen per categorie.',
    };
  },
  mounted() {
    new SatelliteApi()
      .getFaqContent() //
      .then((rsp) => (this.categories = rsp.data));
  },
  methods: {},
  computed: {},
};
</script>

<template>
  <div>
    <view-header title="Support" :sub-title="subtitle"/>

    <div class="flex flex-col gap-3 mt-6 px-7">
      <p class="pb-4 text-lg font-semibold">{{ topText }}</p>
      <div>
        <div class="section">Categoriën</div>
      </div>

      <Accordion>
        <AccordionPanel
            v-for="category in categories"
            :key="'key_citem_' + category.name"
            :value="'id_citem_' + category.name"
            @click="selectedCategory = category"
        >
          <AccordionHeader>{{ category.name }}</AccordionHeader>
          <AccordionContent>

            <div v-if="selectedCategory">
            <Accordion>
              <AccordionPanel
                  v-for="answerItem in selectedCategory.answers"
                  :key="'key_aitem_' + answerItem.question"
                  :value="'id_aitem_' + answerItem.question"
              >
                <AccordionHeader>{{ answerItem.question }}</AccordionHeader>
                <AccordionContent>{{ answerItem.answer }}</AccordionContent>
              </AccordionPanel>
            </Accordion>
            </div>

          </AccordionContent>
        </AccordionPanel>
      </Accordion>
    </div>
  </div>
</template>

<style scoped>
.p-accordionheader {
  @apply text-slate-700;
}

.p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader {
  @apply text-theme-highlight;
}

.p-accordionpanel-active {
  @apply text-theme-highlight;
}

.section {
  @apply mb-1 text-xl;
}
</style>
